module.exports = __webpack_public_path__ + "img/Sound Decision Maker.d77dd739.png";